// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e83530d9","498":"abc14a0b","621":"f5c33beb","703":"146e342d","787":"d03442ec"}[chunkId] + ".chunk.js";
};